import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import logo from "./logo.png";

const Navbar = ({ props }) => {
  const [userName, setUserName] = useState(props.username);
  const role = props.user_role; // Роль пользователя
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  const handleLogout = async () => {
    try {
      const response = await fetch("/session", { method: "DELETE" });
      if (response.ok) {
        setIsLoggedIn(false);
        window.location.href = "/";
      } else {
        console.error("Ошибка при выходе из системы.");
      }
    } catch (error) {
      console.error("Ошибка при выходе из системы:", error);
    }
  };

  const menuItems = [
    { label: "Отчеты", path: "/reports" },
    { label: "Сводные отчеты", path: "/reports/mixing" },
    {
      label: "Настройки",
      dropdown: [
        { label: "Подразделения", path: "/settings/divisions", roles: [8] },
        { label: "Периоды", path: "/settings/periods", roles: [2, 4, 8] },
        {
          label: "Подавшие отчеты",
          path: "/settings/reports",
          roles: [2, 4, 8],
        },
        { label: "Личные данные", path: "/settings/personal" },
        {
          label: "Приглашение для регистрации",
          path: "/settings/invite",
          roles: [2, 4, 8],
        },
        { label: "Все формы", path: "/forms", roles: [8] },
        { label: "Добавить форму", path: "/forms/new", roles: [8] },
        { label: "Добавить пользователя", path: "/settings/add_user", roles: [8] },

      ],
    },
  ];

  // Фильтруем меню на основе роли пользователя
  const filteredMenuItems = menuItems.map((item) => {
    if (item.dropdown) {
      const filteredDropdown = item.dropdown.filter(
        (dropdownItem) =>
          !dropdownItem.roles || dropdownItem.roles.includes(role)
      );
      return { ...item, dropdown: filteredDropdown };
    }
    return item;
  });

  // Обновляем текущий путь при изменении маршрута
  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener("popstate", handleRouteChange);
    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, []);

  return (
    <div className="bg-gradient-to-r from-blue-700 via-blue-800 to-blue-900 text-white">
      <div className="container max-w-screen-2xl mx-auto">
        {/* Верхняя строка */}
        <div className="flex flex-col md:flex-row justify-between items-start px-4 py-2 border-b border-blue-800 space-y-2 md:space-y-0">
          <div className="text-sm font-light">{userName}</div>
        </div>

        {/* Логотип и менеджер */}
        <div className="flex flex-col md:flex-row justify-between items-start px-4 py-4 border-b border-blue-800 space-y-4 md:space-y-0">
          <div className="flex items-center space-x-2">
            <img
              src={logo}
              alt="Логотип"
              className="w-10 h-10 rounded-md object-cover"
            />
            <div>
              <p className="font-semibold text-lg">
                Алматинская Городская Коллегия Адвокатов
              </p>
              <p className="text-sm text-blue-200">Отчетность</p>
            </div>
          </div>
        </div>

        {/* Основное меню */}
        <div className="px-4 py-4 space-y-4">
          <button
            className="block md:hidden w-full bg-blue-600 px-4 py-2 rounded-lg hover:bg-blue-500 transition"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? "Закрыть меню" : "Меню"}
          </button>
          <div
            className={`${
              isMenuOpen ? "block" : "hidden"
            } md:flex flex-wrap justify-center md:justify-start md:space-x-4 space-y-2 md:space-y-0`}
          >
            {filteredMenuItems.map((item, index) => (
              <div key={index} className="relative">
                <a
                  href={item.path || "#"}
                  className={`block px-4 py-2 rounded ${
                    currentPath === item.path
                      ? "bg-blue-600 text-white"
                      : "hover:bg-blue-600 hover:text-white"
                  }`}
                  onClick={(e) => {
                    if (item.dropdown) {
                      e.preventDefault();
                      setIsDropdownOpen(!isDropdownOpen);
                    }
                  }}
                >
                  {item.label}
                </a>

                {item.dropdown && isDropdownOpen && (
                  <div
                    className="absolute left-0 top-full mt-2 w-48 bg-white text-blue-700 rounded-lg shadow-lg z-10"
                    onMouseLeave={() => setIsDropdownOpen(false)}
                  >
                    {item.dropdown.map((dropdownItem, idx) => (
                      <a
                        key={idx}
                        href={dropdownItem.path}
                        className={`block px-4 py-2 text-sm ${
                          currentPath === dropdownItem.path
                            ? "bg-blue-500 text-white"
                            : "hover:bg-blue-500 hover:text-white"
                        }`}
                      >
                        {dropdownItem.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {/* Кнопка "Выйти" */}
            {isLoggedIn && (
              <div className="mt-4 md:mt-0 w-full md:w-auto">
                <button
                  onClick={handleLogout}
                  className="w-full md:w-auto flex items-center justify-center space-x-2 bg-red-600 px-4 py-2 rounded-lg text-sm font-medium text-white hover:bg-red-700 transition"
                >
                  <FontAwesomeIcon icon={faSignOutAlt} />
                  <span>Выйти</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
